import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { withVar } from "themes/helpers";

export enum BarType {
  Info,
  LiteWarning,
}

interface IProps {
  type: BarType;
  skipIcon?: boolean;
  iconAlign?: string;
  iconFill?: string;
  children: React.ReactNode;
}

type IWrapper = IProps;

const backgroundColors = {
  [BarType.Info]: withVar(DesignToken.SurfaceAccentEmphasisLowInfo),
  [BarType.LiteWarning]: withVar(DesignToken.SurfaceAccentEmphasisLowWarning),
};

const iconTypes = {
  [BarType.Info]: IconsEnum.InfoFilled,
  [BarType.LiteWarning]: IconsEnum.Warning,
};

const Wrapper = styled.div<IWrapper>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
  border-radius: 4px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  background: ${
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => backgroundColors[props.type]
  };
`;

const StyledIcon = styled(Icon)`
  margin-right: 10px;
`;

const StyledContent = styled.div`
  flex: 1;
`;

export const Bar: React.FC<IProps> = ({ children, type, skipIcon, iconAlign }) => (
  <Wrapper type={type}>
    {!skipIcon && (
      <div style={iconAlign ? { alignSelf: iconAlign } : {}}>
        <StyledIcon name={iconTypes[type]} width="20px" height="20px" />
      </div>
    )}
    <StyledContent>{children}</StyledContent>
  </Wrapper>
);
